/**
 * @fileoverview Sensor data display component that subscribes to AWS IoT messages
 * @requires react
 * @requires react-bootstrap/Card
 * @requires aws-amplify
 */

import React from 'react';
import Card from 'react-bootstrap/Card';
import { Amplify } from 'aws-amplify';
import awsconfig from './../aws-exports';
import '@aws-amplify/ui-react/styles.css';
import { PubSub } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';

// Configure Amplify with AWS settings
Amplify.configure(awsconfig);

/**
 * Configure AWS IoT Provider for PubSub
 * Enables real-time communication with AWS IoT Core
 */
Amplify.addPluggable(new AWSIoTProvider({
    aws_pubsub_region: 'us-east-1',
    aws_pubsub_endpoint: 'wss://a3e070sksd09qp-ats.iot.us-east-1.amazonaws.com/mqtt',
}));

/**
 * @class Sensors
 * @extends React.Component
 * @description Component that displays sensor data in a card format
 * 
 * @prop {string} name - Name of the sensor to display
 * @prop {string} unit - Unit of measurement for the sensor data
 */
class Sensors extends React.Component {
    /**
     * @constructor
     * @param {Object} props - Component properties
     */
    constructor(props) {
        super(props);
        this.state = {
            sensorMsg: '{"null": 0}'  // Initial state with null sensor data
        };
    }

    /**
     * @method componentDidMount
     * @description Subscribes to AWS IoT topic when component mounts
     * Handles incoming sensor data and updates component state
     */
    componentDidMount() {
        PubSub.subscribe('esp8266/pub').subscribe({
            next: data => {
                try {
                    this.setState({ sensorMsg: data.value });
                }
                catch (error) {
                    console.log("Error, are you sending the correct data?");
                }
            },
            error: error => console.error(error),
            close: () => console.log('Done'),
        });
    }

    /**
     * @method render
     * @description Renders the sensor data in a styled card component
     * @returns {JSX.Element} Rendered component
     */
    render() {
        const { sensorMsg } = this.state;
        let sensorData = sensorMsg[this.props.name];

        return (
            <div className="Sensor">
                <Card style={{ width: '18rem' }}>
                    <Card.Body>
                        <Card.Title>{this.props.name}</Card.Title>
                        <Card.Text> 
                            {sensorData} {this.props.unit}
                        </Card.Text>
                    </Card.Body>
                </Card>
                <style jsx>{`
                    .Sensor {
                        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
                        transition: 0.3s;
                    }
                    
                    .Sensor:hover {
                        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
                    }
                `}</style>
            </div>
        );
    }
}

export default Sensors;
